import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';


import authentication from './authentication/reducer';
import passwordReset from './passwordReset/reducer';
import configuration from './configuration/reducer';
import jobApprovals from './ticketApprovals/reducer';
import timesheetApprovals from './timesheetApprovals/reducer';
import ticketInvoicing from './ticketInvoicing/reducer';
import userList from './admin/userList/reducer';
import operatorList from './admin/operatorList/reducer';
import leaseList from './admin/leaseList/reducer';
import wellList from './admin/wellList/reducer';
import timeEntryForm from './forms/TimeEntry/reducer';
import equipmentList from './admin/equipmentList/reducer';
import ticketNumberStatus from './ticketNumberStatus/reducer';
import timesheetNavigator from './timesheetNavigator/reducer';
import payrollProcessor from './payrollProcessor/reducer';
import ticketEntryForm from './forms/TicketEntry/reducer';
import ticketViewer from './ticketViewer/reducer';
import bonuses from './bonuses/reducer';
import bonusSummary from './bonusSummary/reducer';
import bonusApprovals from './bonusApprovals/reducer';
import missingTicketNumbers from './missingTicketNumbers/reducer';
import timesheetViewer from './timesheetViewer/reducer';
import ticketTable from './ticketTable/reducer';
import perDiems from './perDiems/reducer';
import trirReport from './trirReport/reducer';
import unaccountedHoursTicketsReport from './unaccountedHoursTicketsReport/reducer';
import timesheetSubmissionProcessor from '../layouts/TimesheetSubmissionProcessor/reducer';
import appReducer from '../app/reducer';
import perDiemReport from './perDiemReport/reducer';
import fieldAdminReview from './fieldAdminReview/reducer';
import guaranateedPayReport from './guaranteedHoursReport/reducer';
import accrualReport from './accrualReport/reducer';
import equipmentUsageReport from './equipmentUsageReport/reducer';
import onetimePassword from './admin/requestMobilePassword/reducer';

const rootReducer = combineReducers({
  authentication,
  passwordReset,
  configuration,
  jobApprovals,
  timesheetApprovals,
  ticketInvoicing,
  userList,
  operatorList,
  leaseList,
  wellList,
  timeEntryForm,
  equipmentList,
  ticketNumberStatus,
  timesheetNavigator,
  form: formReducer,
  payrollProcessor,
  ticketEntryForm,
  ticketViewer,
  bonuses,
  bonusSummary,
  bonusApprovals,
  missingTicketNumbers,
  timesheetViewer,
  ticketTable,
  perDiems,
  trirReport,
  unaccountedHoursTicketsReport,
  timesheetSubmissionProcessor,
  appReducer,
  perDiemReport,
  fieldAdminReview,
  guaranateedPayReport,
  accrualReport,
  equipmentUsageReport,
  onetimePassword,
});

export default rootReducer;
